import * as React from 'react';
import { useState, useEffect } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import { Box, Dialog } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { loginApi } from "../../services/authApi";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function RegisterStep2(props) {
  const { disableButton, handleRegisterValues, handleRegisterStep1Submit, handleRegisterStep2Submit, handleShowingFormsValues, registerValues, customToastify } = props
  const [disableSendCodeButton, setDisableSendCodeButton] = useState(false);


  useEffect(() => {
    setDisableSendCodeButton(true)
    setTimeout(() => {
      setDisableSendCodeButton(false)
    }, 59000)
  }, []);
  // Random component
  const waitForclick = () => {
    setDisableSendCodeButton(true)
    setTimeout(() => {
      setDisableSendCodeButton(false)
    }, 59000)
  };
  const handleClickSubmit = (e) => {
    // console.log(registerValues["confirmCode"])
    // console.log(registerValues["confirmCode"].length)
    if (registerValues["confirmCode"].length == 0) customToastify("error", "لطفا کد را وارد کنید")
    else handleRegisterStep2Submit()
  }
  return (
    <Box
      sx={{
        marginTop: 0.5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Avatar sx={{ m: 0.5, bgcolor: 'secondary.main' }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" color="darkgoldenrod" variant="body1" >
        کد تایید دریافت شده را وارد کنید
      </Typography>
      <Typography>
        <Button variant="contained" onClick={() => { waitForclick(); handleRegisterStep1Submit() }} disabled={disableSendCodeButton}>
          دریافت کد جدید {"  "}
          {!disableSendCodeButton ? null : <CountdownCircleTimer size={25} strokeWidth={2} isPlaying={disableSendCodeButton} duration={60} colors={['#004777', '#F7B801', '#A30000', '#A30000']} colorsTime={[7, 5, 2, 0]} >{({ remainingTime }) => remainingTime}</CountdownCircleTimer>}
        </Button>
      </Typography>

      <Box noValidate sx={{ mt: 1 }}>
        {/* <TextField
          //   margin="normal"
            sx={{m:0.3}}
            required
            fullWidth
            id="phoneNumber"
            label="شماره همراه"
            name="phoneNumber"
            autoComplete="phoneNumber"
            autoFocus
          /> */}
        <TextField
          //   margin="normal"
          sx={{ m: 0.3 }}
          required
          fullWidth
          id="confirmCode"
          label="کد تایید"
          name="confirmCode"
          value={registerValues.confirmCode}
          onChange={(e) => handleRegisterValues("confirmCode", e.target.value)}
          autoComplete="confirmCode"
        />
        <Button
          disabled={disableButton}
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 1, mb: 1 }}
          onClick={handleClickSubmit}
        >
          ادامه
        </Button>
        <Grid container>
          <Container maxWidth="sx"  >
            <Link href="#" onClick={() => { handleShowingFormsValues("FormalLogin") }} variant="body2">
              {"قبلا ثبت نام کرده ام!"}
            </Link>
          </Container >
          <Container maxWidth="sx" >
            <Link href="#" onClick={() => { handleShowingFormsValues("RegisterStep1") }} variant="body2">
              {"تغییر شماره ثبت نام"}
            </Link>
          </Container >
        </Grid>


      </Box>
    </Box>
  )
}